import React, { useEffect, useState } from "react";
import Close from "../../assets/Modal-Close-Icon.svg";
import Dash from "../../assets/Dash.svg";
import Drop from "../../assets/Polygon 2.svg";
import "./MultipleAssign.css";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../redux-store/store";
import {
  GetAllNotification_M3,
  UpdateAssignToNotification,
} from "../../../../api/notifyapi/Notifyapi";
import {
  IFilterModel,
  INotificationTableList,
  NotificationActions,
} from "../../../../slices/NotificationSlice";
import { IAssignList } from "../../../../slices/UserControlSlice";
import { Tooltip } from "antd";
import { LEVEL_CONSTANT } from "../CreateAndEditNotify/FormDataConstants";
import Loader from "../../loader/Loader";
import { getAssignBtnTooltip } from "../../TooltipContent/tooltipMessageHelper";

interface MultipleAssginProps {
  data: INotificationTableList[];
  onClose: () => void;
}

const MultipleAssgin: React.FC<MultipleAssginProps> = ({ data, onClose }) => {
  const { user, features, switchRole } = useSelector(
    (state: RootState) => state.user
  );
  const UserAssignList = useSelector(
    (state: RootState) => state.userControl.UserAssignList
  );
  const { searchFilter } = useSelector(
    (state: RootState) => state.notification
  );

  const [toggleAssign, setToggleAssign] = useState<boolean>(false);
  const [selectedAssignUser, setSelectedAssignUser] = useState<IAssignList[]>(
    []
  );
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [assignData, setAssignData] = useState<INotificationTableList[]>([]);
  const [previouslyAssignedUser, setPreviouslyAssignedUser] = useState<
    string | null
  >(null);

  const dispatch = useDispatch<AppDispatch>();
  const [userRole, setUserRole] = useState<string[]>([]);
  const [isAssignButtonDisabled, setIsAssignButtonDisabled] =
    useState<boolean>(true);

  // Populate previously assigned users when data changes
  useEffect(() => {
    if (data && data.length > 0) {
      setAssignData(data);

      // Check if this notification was previously assigned
      const hasAssignedUser = data[0].assignedUser && data[0].assignedUser[0];

      if (hasAssignedUser?.length > 0) {
        // Store the previously assigned user email
        setPreviouslyAssignedUser(hasAssignedUser);

        // Find and set the previously assigned user details
        const assigneeDetails = UserAssignList.find(
          (item) => item.emailID === hasAssignedUser
        );

        if (assigneeDetails) {
          setSelectedAssignUser([
            {
              emailID: assigneeDetails.emailID,
              name: assigneeDetails.name,
              userID: assigneeDetails.userID,
            },
          ]);
        }
      } else {
        // Clear selection for new assignments
        setSelectedAssignUser([]);
        setPreviouslyAssignedUser(null);
      }
    }
  }, [UserAssignList, data]);

  useEffect(() => {
    if (user) {
      setUserRole(user?.ssoRoles.map((role: string) => role));
    }
  }, [user]);

  // Check permission based on notification levels
  useEffect(() => {
    const hasLevel1 = assignData?.some(
      (item) => item?.level === LEVEL_CONSTANT.level1
    );
    const hasLevel2 = assignData?.some(
      (item) => item?.level === LEVEL_CONSTANT.level2
    );

    setIsAssignButtonDisabled(
      !(
        (hasLevel1 && features.notification.assignNotify.level1) ||
        (hasLevel2 && features.notification.assignNotify.level2)
      )
    );
  }, [assignData, userRole, features]);

  // Handle close of modal
  const handleclose = (): void => {
    onClose();
  };

  // Remove item from assign data
  const handleremove = (id: string): void => {
    const updatedData = assignData.filter((item) => item.nUniqueID !== id);
    setAssignData(updatedData);
  };

  // Toggle assign dropdown
  const handleAssignToggle = (): void => {
    setToggleAssign(!toggleAssign);
  };

  // Select user for assignment
  const handleAssignUser = (user: IAssignList): void => {
    setSelectedAssignUser([user]);
    setToggleAssign(!toggleAssign);
  };

  // Perform bulk assign/reassign
  const handleToAssignUser = (): void => {
    try {
      if (!selectedAssignUser) return;
      setIsLoading(true);
      dispatch(
        UpdateAssignToNotification({
          assignee: selectedAssignUser.map((item: IAssignList) => item.emailID),
          notificationIDs: assignData.map(
            (item: INotificationTableList) => item.notificationID
          ),
          performedBy: user ? user.email : "",
        })
      ).then(() => {
        onClose();
        dispatch(NotificationActions.updateIsAssigned(true));
        if (searchFilter.globalSearch.value) {
          let lQuery: IFilterModel = {
            filters: searchFilter.globalSearchApiQuery.filters,
            isAscending: false,
            currentPageSize: searchFilter.apiQuery.currentPageSize,
            pageSize: searchFilter.apiQuery.pageSize,
            page: 1, //First time always get page 1
            isOr: true,
            isPageChanged: "",
            sortField: "",
          };

          dispatch(GetAllNotification_M3(lQuery));
        } else {
          dispatch(GetAllNotification_M3(searchFilter.apiQuery));
        }
        setIsLoading(false);
      });
    } catch (error) {
      console.error("Error assigning users:", error);
    }
  };
  return (
    <div className="modal-overlay">
      <div className="multipleAssign-modal-content">
        <div className="modal-header">
          <span className="popup-head">
            {previouslyAssignedUser ? "Reassign User" : "Assign User"}
          </span>
          <img
            src={Close}
            alt="assign-close-icon"
            className="close-btn"
            tabIndex={0}
            onClick={handleclose}
          />
        </div>
        <div className="modal-body-main-container">
          <div className="multipleAssign-modal-body">
            <div className="multipleAssign-list-main">
              <div className="list-main-head">
                <div className="label-element">Notification Unique ID</div>
                <div className="label-element label-position">Title</div>
              </div>
              {assignData.map((item, index) => (
                <div className="list-subcontainer" key={index}>
                  <div className="label-element">
                    {item ? item.nUniqueID : ""}
                  </div>
                  <div
                    className="label-element"
                    style={{ wordBreak: "break-word" }}
                  >
                    {item ? item.title : ""}
                  </div>
                  {assignData.length > 1 ? (
                    <Tooltip title="Click to Remove">
                      <button
                        onClick={() => handleremove(item.nUniqueID)}
                        className="assign-dash-button"
                      >
                        <img src={Dash} alt="" />
                      </button>
                    </Tooltip>
                  ) : (
                    <button
                      style={{ border: "none", outline: "none" }}
                    ></button>
                  )}
                </div>
              ))}
            </div>
          </div>
          <div className="multipleAssign-modal-footer">
            <div style={{ padding: "0 26px" }}>
              <div className="assign-user-input-container">
                <div className="label-element">
                  {previouslyAssignedUser ? "Select New User" : "Select User"}
                </div>
                <div
                  className="assign-user-select-container"
                  onClick={handleAssignToggle}
                >
                  <span className="dropdown-spanElement">
                    {selectedAssignUser.length > 0
                      ? selectedAssignUser[0].name
                      : "Select the Assign User"}
                  </span>
                  <img src={Drop} alt="DropDown-Icon" />
                </div>
              </div>
              {toggleAssign && (
                <div className="assign-user-dropdown-container">
                  {UserAssignList.map((user, index) => (
                    <div key={index}>
                      <div
                        className="dropdownList-container"
                        onClick={() => handleAssignUser(user)}
                      >
                        {user.name}
                        {user.emailID === previouslyAssignedUser && (
                          <span className="current-assignee"> (Current)</span>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
            <div
              className="label-element"
              style={{ marginTop: "4px", marginLeft: "27px" }}
            >
              {previouslyAssignedUser
                ? `Currently assigned to: ${selectedAssignUser[0]?.name || ""}`
                : "You can assign one user at a time"}
            </div>
            <div className="multipleAssign-footer-btn">
              <Tooltip title={getAssignBtnTooltip(data[0], user, switchRole)}>
                <button
                  disabled={!selectedAssignUser || isAssignButtonDisabled}
                  className={`popup-create-btn ${
                    isAssignButtonDisabled ? "disabled-button-style" : ""
                  }`}
                  onClick={() => {
                    if (!isAssignButtonDisabled) {
                      handleToAssignUser();
                    }
                  }}
                >
                  {isLoading ? (
                    <Loader />
                  ) : previouslyAssignedUser ? (
                    "Reassign"
                  ) : (
                    "Assign"
                  )}
                </button>
              </Tooltip>
              <button className="popup-Cancel-btn" onClick={handleclose}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MultipleAssgin;
